<template>
  <div class="c-menu-card">
    <!-- Toolbar compacto -->
    <div class="c-menu-toolbar">
      <div class="c-menu-toolbar__row">
        <!-- Switches à esquerda -->
        <div class="c-menu-toolbar__switches">
          <v-switch
            v-model="modoEdicao"
            hide-details
            dense
            class="mt-0 mb-0 pt-0 pb-0"
          >
            <template v-slot:label>
              <v-chip small class="pr-3" link>
                Modo Edição
                <v-icon right x-small>drive_file_rename_outline</v-icon>
              </v-chip>
            </template>
          </v-switch>
          <v-switch
            v-model="arquivado"
            hide-details
            dense
            class="mt-1 mb-0 pt-0 pb-0"
          >
            <template v-slot:label>
              <v-chip small class="pr-3" link>
                Pregões Arquivados
                <v-icon x-small v-if="!arquivado" right>visibility_off</v-icon>
                <v-icon x-small v-if="arquivado" right>visibility</v-icon>
              </v-chip>
            </template>
          </v-switch>
        </div>

        <!-- Busca centralizada -->
        <v-text-field
          dense
          hint="Busque Por: Órgão, ID ou Valor"
          persistent-hint
          outlined
          @keyup="enviarBuscar"
          class="buscadorr c-menu-toolbar__search"
          append-icon="mdi-magnify"
          label="Buscar Pregão"
          hide-details="auto"
        ></v-text-field>

        <!-- Ícones + avatar à direita -->
        <div class="c-menu-toolbar__icons">
          <modalCadastroProduto />
          <modalCadastroOrgao />
          <modalCadastroPregao />

          <v-dialog
            v-model="dialogAnalytics"
            persistent
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab dark large class="mx-2" elevation="4" color="primary"
                v-bind="attrs" v-on="on"
              >
                <v-icon>insert_chart</v-icon>
              </v-btn>
            </template>
            <v-card class="c-analytics-dialog">
              <v-toolbar class="c-analytics-dialog__toolbar" color="#0B7285" dark flat>
                <v-toolbar-title>Relatórios</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-switch
                  v-model="modoEdicaoAnalytics"
                  class="c-analytics-dialog__switch"
                  hide-details
                >
                  <template v-slot:label>
                    <v-chip class="pr-5" link>
                      Modo Edição
                      <v-icon right small>drive_file_rename_outline</v-icon>
                    </v-chip>
                  </template>
                </v-switch>
                <v-toolbar-items>
                  <v-btn class="mx-2" icon>
                    <v-icon dark large @click="dialogAnalytics = false">cancel</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text class="pa-0 c-analytics-dialog__content">
                <painelAnalytics
                  :modoEdicao="modoEdicaoAnalytics"
                  fullscreen
                />
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Avatar do usuário -->
          <v-menu
            v-if="dadosUser && dadosUser.name"
            right bottom
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn text class="c-user-btn ml-2" v-on="on">
                <span class="c-user-btn__name">{{ dadosUser.name }}</span>
                <v-icon
                  v-if="dadosUser.admin"
                  class="pl-1"
                  color="#943634"
                >mdi-shield-account</v-icon>
                <v-icon v-else class="pl-1" color="#943634">person</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list-item-content class="justify-center">
                <div class="mx-auto text-center">
                  <v-avatar color="#943634" class="mb-2">
                    <v-icon dark>mdi-account-circle</v-icon>
                  </v-avatar>
                  <h3>{{ dadosUser.name }}</h3>
                  <p class="text-caption mt-1">{{ dadosUser.email }}</p>
                  <v-divider class="my-3"></v-divider>
                  <modalGestaoUsuario />
                  <v-divider class="my-3"></v-divider>
                  <v-btn depressed rounded text color="#943634" @click="logout">
                    <v-icon left dark color="#943634">logout</v-icon>
                    Sair
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-card>
          </v-menu>
        </div>
      </div>
    </div>

    <!-- Área rolável da lista -->
    <div class="c-menu-scroll">
      <listaPregao
        :modoEdicao="modoEdicao"
        :arquivado="arquivado"
      />
    </div>
  </div>
</template>

<script>
  import listaPregao from "../pregao/listaPregao";
  import modalCadastroOrgao from "../orgao/modalCadastroOrgao";
  import modalCadastroPregao from "../pregao/modalCadastroPregao";
  import modalCadastroProduto from "../produto/modalCadastroProduto";
  import modalGestaoUsuario from "../usuario/modalGestaoUsuario";
  import painelAnalytics from "../analytics/painelAnalytics";
  import barramento from "@/barramento";
  import { userKey } from "@/global";

  export default {
    name: "Menu",
    components: {
      listaPregao,
      modalCadastroPregao,
      modalCadastroProduto,
      modalCadastroOrgao,
      modalGestaoUsuario,
      painelAnalytics,
    },
    props: {
      dadosUser: { type: Object, default: () => ({}) },
    },

    data: function () {
      return {
        dialogAnalytics: false,
        searchEngine: "",
        modoEdicao: false,
        modoEdicaoAnalytics: false,
        arquivado: false,
      };
    },
    watch: {
      dialogAnalytics(val) {
        if (!val) {
          this.modoEdicaoAnalytics = false;
        }
      },
    },

    methods: {
      enviarBuscar(busca) {
        barramento.enviarBusca(busca.target.value);
      },
      logout() {
        localStorage.removeItem(userKey);
        barramento.enviarStatusLogin(true, false);
      },
    },
  };
</script>

<style>
  .c-menu-card {
    display: flex !important;
    flex-direction: column !important;
    height: calc(100vh - 72px) !important;
    overflow: hidden !important;
    background: #fcfcfc;
  }

  /* Toolbar compacto */
  .c-menu-toolbar {
    flex: 0 0 auto;
    background: #fff;
    z-index: 2;
    padding: 16px;
    border-bottom: 1px solid #e0e0e0;
  }
  .c-menu-toolbar__row {
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 82px;
  }
  .c-menu-toolbar__switches {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 180px;
  }
  .c-menu-toolbar__search {
    flex: 1 1 auto;
    max-width: 400px;
    min-width: 200px;
    align-self: center;
    position: relative;
  }
  .c-menu-toolbar__search .v-text-field__details {
    position: absolute;
    bottom: -20px;
    left: 12px;
    right: 12px;
  }
  .c-menu-toolbar__icons {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }

  /* Área de scroll dos pregões */
  .c-menu-scroll {
    flex: 1 1 0 !important;
    overflow-y: auto !important;
    overflow-x: hidden;
    min-height: 0 !important;
    padding: 0 12px 12px 12px;
  }

  /* Botão do usuário */
  .c-user-btn {
    text-transform: none;
    letter-spacing: normal;
  }
  .c-user-btn__name {
    font-weight: 600;
    color: #943634;
    font-size: 14px;
  }

  /* Analytics dialog */
  .c-analytics-dialog {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .c-analytics-dialog__toolbar {
    flex: 0 0 64px;
    height: 64px !important;
    min-height: 64px !important;
    max-height: 64px !important;
  }
  .c-analytics-dialog__toolbar .v-toolbar__content {
    height: 64px !important;
  }
  .c-analytics-dialog__content {
    flex: 1;
    height: calc(100vh - 64px);
    min-height: 0;
    overflow: hidden;
    display: flex;
  }
  .c-analytics-dialog__content > * {
    flex: 1;
    min-height: 0;
  }
  .c-analytics-dialog__switch {
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }

  /* Scrollbar visível — especificidade alta para vencer o global */
  .c-menu-card > .c-menu-scroll::-webkit-scrollbar {
    width: 10px !important;
    height: 10px !important;
  }
  .c-menu-card > .c-menu-scroll::-webkit-scrollbar-track {
    background: #e0e0e0 !important;
    border-radius: 5px;
  }
  .c-menu-card > .c-menu-scroll::-webkit-scrollbar-thumb {
    background: #943634 !important;
    border-radius: 5px;
  }
  .c-menu-card > .c-menu-scroll::-webkit-scrollbar-thumb:hover {
    background: #733634 !important;
  }
  .c-menu-card > .c-menu-scroll {
    scrollbar-width: auto;
    scrollbar-color: #943634 #e0e0e0;
  }
</style>
